<template>
  <div class="segmented-tabs">
    <template v-for="tab in items">
      <div :id="`${tab.key}-tooltip`" :key="`${tab.key}-button`" tabindex="0">
        <b-button
          variant="light"
          class="__button"
          :value="tab.key"
          :class="{ active: tab.key == activeTab }"
          :disabled="isLoading || tab.disabled"
          @click.stop="handleClickTab"
        >
          <i v-if="tab.icon" :class="'mc-fc ' + tab.icon" />
          {{ tab.name }}
        </b-button>
      </div>

      <b-tooltip
        v-if="tab.tooltip && tab.disabled"
        :key="`${tab.key}-tooltip`"
        triggers="hover"
        placement="rightbottom"
        :target="`${tab.key}-tooltip`"
      >
        {{ tab.tooltip }}
      </b-tooltip>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    activeTab: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
    },
  },
  emits: ['update:activeTab'],
  methods: {
    handleClickTab(e) {
      this.$emit('update:activeTab', e.currentTarget.value, 'click')
    },
  },
}
</script>

<style lang="scss" scoped>
.segmented-tabs {
  display: flex;
  gap: 8px;
  padding: 5px;
  border-radius: 20px;
  justify-self: anchor-center;

  background-color: $white;
  box-shadow: $btn-active-box-shadow;
  height: fit-content;
  width: fit-content;

  .__button {
    height: 36px;
    flex-shrink: 0;
    color: $mep-color-text;
    font-size: 12px;
    font-weight: 500;
    transition: none;
    background: none;
    outline: none;
    border: none;
    border-radius: 20px;
    padding: 8px 12px;

    &:hover {
      background-color: $mep-secondary-100;
      color: $mep-color-text-400;
    }

    &:focus {
      outline: none;
    }

    &:disabled {
      color: #67718b;
    }
    
    &.active {
      box-shadow: none;
      background-color: $mep-secondary-100;
      color: $mep-primary;
      font-weight: 600;
    }
  }

}
</style>
